/**
 * Church Updates Utility Functions
 */

const CHURCH_UPDATE_SHARE_ORIGIN = 'https://hogc.one';

/**
 * Check if a church update item is within the "new" period (14 days)
 * @param {Object} item - Church update item with date property
 * @returns {boolean} - True if published within last 14 days
 */
export function isWithinNewPeriod(item) {
  if (!item || !item.date) return false;

  const publishDate = new Date(item.date);
  const today = new Date();
  const daysDiff = Math.floor((today - publishDate) / (1000 * 60 * 60 * 24));

  return daysDiff < 14;
}

/**
 * Check if the share button should render for a church update.
 * Missing values default to visible so existing Storyblok articles are unaffected.
 * @param {Object} item - Church update item with showShareButton property
 * @returns {boolean} - True unless the article explicitly disables sharing
 */
export function canShareChurchUpdate(item) {
  return item?.showShareButton !== false;
}

/**
 * Normalise generated Church Update share URLs before passing them to native share sheets.
 * The deeplink API can return malformed URLs with "-" as the host (for example
 * https://-/article-slug). Preserve the generated path and force the public HOGC One host.
 * @param {string} url - Generated share URL from the deeplink API
 * @returns {string} - Shareable public URL
 */
export function normalizeChurchUpdateShareUrl(url) {
  if (!url) return '';

  try {
    const shareUrl = new URL(url, CHURCH_UPDATE_SHARE_ORIGIN);

    if (shareUrl.hostname === '-') {
      return `${CHURCH_UPDATE_SHARE_ORIGIN}${shareUrl.pathname}${shareUrl.search}${shareUrl.hash}`;
    }

    return shareUrl.toString();
  } catch {
    return url;
  }
}
